import type { Observable } from 'rxjs';
import type {
  AppStoreApplication,
  AppStoreArtifact,
  AppStoreRelease,
  CreateAppStoreApplication,
  CreateAppStoreRelease,
  UploadAppStoreArtifact,
} from '../models/app-store.models';

export abstract class AppStoreRepository {
  abstract getApplications(): Observable<AppStoreApplication[]>;
  abstract createApplication(
    payload: CreateAppStoreApplication,
  ): Observable<AppStoreApplication>;
  abstract updateApplication(
    applicationId: string,
    payload: CreateAppStoreApplication,
  ): Observable<AppStoreApplication>;
  abstract deleteApplication(applicationId: string): Observable<void>;
  abstract deleteRelease(applicationId: string, releaseId: string): Observable<void>;
  abstract deleteArtifact(applicationId: string, releaseId: string, artifactId: string): Observable<void>;
  abstract getReleases(applicationId: string): Observable<AppStoreRelease[]>;
  abstract createRelease(
    applicationId: string,
    payload: CreateAppStoreRelease,
  ): Observable<AppStoreRelease>;
  abstract updateRelease(
    applicationId: string,
    releaseId: string,
    payload: CreateAppStoreRelease,
  ): Observable<AppStoreRelease>;
  abstract getArtifacts(
    applicationId: string,
    releaseId: string,
  ): Observable<AppStoreArtifact[]>;
  abstract uploadAndPublishArtifact(
    input: UploadAppStoreArtifact,
  ): Observable<AppStoreArtifact>;
}
